import CreateScenarioMode, {
  CreateScenarioModeProps,
} from "@features/scenarioDesign/MainContent/CreateScenarioMode"
import ViewRunsMode, { ViewRunsModeProps } from "@features/scenarioDesign/MainContent/ViewRunsMode"
import { PageMode } from "@features/scenarioDesign/ScenarioDesignPage"

export type MainContentProps = {
  mode: PageMode
  createScenarioModeProps: CreateScenarioModeProps
  viewRunsModeProps: ViewRunsModeProps
}

const MainContent = ({ mode, createScenarioModeProps, viewRunsModeProps }: MainContentProps) => {
  if (mode === PageMode.ViewRuns) {
    return <ViewRunsMode {...viewRunsModeProps} />
  }

  return <CreateScenarioMode {...createScenarioModeProps} />
}

export default MainContent
